// The world view's tab↔panel DOM identity contract (A3-CLOSE's missing
// half): one derivation consumed by BOTH sides — the strip stamps tab ids
// and aria-controls, the room primitive stamps the matching panel ids — so
// the linkage can never drift into dangling references. A NESTED row's
// panel is the content below that row's own strip. The ROOT row carries tab
// ids but no aria-controls: it seats above the slice boundary in the frame's
// rootStrip slot (principal ruling 2026-08-28 — the containment law at level
// 0, both modes), so its true panel is the entire boundary beneath it, a
// region the room primitive never wraps and this module never derives an id
// for — pointing aria-controls at a region that isn't a mounted tabpanel
// would be a lie. The shell's roomless nested strip (no mounted primitive,
// so no panels) links nothing either.

export function sessionTabDomId(sessionId: string): string {
  return `slice-tab-${sessionId}`;
}

export function sessionPanelDomId(parentId: string): string {
  return `slice-panel-${parentId}`;
}
